import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "../../../Displays/PageTitle";
import PageSubTitle from "../../../Displays/PageSubTitle";
import VerticalLinearProgress, {
  progressMenuSx,
  stepProgressProps,
} from "../../VerticalLinearProgressBar";
import { SELF_ONBOARDING_ROUTES } from "src/consts/Routes/SelfOnboarding";

const STEPS = ["Hardware Auswahl"] as const;

const SelfOnboardingProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack gap="13px" sx={progressMenuSx}>
      <PageTitle text={"Menü"} />
      {SELF_ONBOARDING_ROUTES.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 20,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={0}
            {...stepProgressProps(STEPS, 1)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {STEPS.map((text) => (
              <PageSubTitle key={text} text={text} />
            ))}
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SelfOnboardingProgressBar;
